/* eslint-disable no-underscore-dangle */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuei18n from 'vue-i18n';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import
{
    RecycleScroller,
    DynamicScroller,
    DynamicScrollerItem,
}
from 'vue-virtual-scroller';
import { Common } from '@om-retail/vue-common';
import { ObserveVisibility } from 'vue-observe-visibility';
import {
    // eslint-disable-next-line vue/max-len
    WcVHorseLastRaceLogic, WcHorsesBetting, WcHorsesFutureRaces, WcHorsesOutcomes, WcBetSlip, WcLottoDrawsOffer, WcLottoExtended, WcLottoGamesMenu, WcLottoHeader, WcLottoNumbers, WcLottoFavorites, WcOfferCalendar, WcLottoTutorial, WcTicketList,
    // eslint-disable-next-line import/extensions, import/no-unresolved
} from '@om-retail/web-cmp';
import { createPinia, PiniaVuePlugin } from 'pinia';
import App from './App.vue';
// eslint-disable-next-line import/extensions, import/no-unresolved
import router from './router/default';
import store from './store/index';
import './services/sentry';
// eslint-disable-next-line import/no-unresolved
import 'video.js/dist/video-js.css';
import '../assets/fonts/style.css';
import '../assets/fonts/menu-icons/style.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import '../assets/br_css/theme.css';
import 'vue-resize/dist/vue-resize.css';
import '../node_modules/@om-retail/web-cmp/dist/es2015/style.css';
// eslint-disable-next-line import/extensions, import/no-unresolved
import mainController from './lib/client_controllers/main_controller';
import '../assets/sass/wiki.scss';
import InputValidation from './components/InputValidation.vue';

// eslint-disable-next-line
import '../assets/sass/abstracts/variables';

Vue.directive('observe-visibility', ObserveVisibility);

Common.setDeviceType('web');

Vue.component('RecycleScroller', RecycleScroller);
Vue.component('DynamicScroller', DynamicScroller);
Vue.component('DynamicScrollerItem', DynamicScrollerItem);
Vue.component('inputvalidation', InputValidation);

Vue.component('vue-scroll', VuePerfectScrollbar);

// Custom elements
customElements.define('bet-slip', WcBetSlip);
customElements.define('ticket-list', WcTicketList);
customElements.define('vhorse-last-race', WcVHorseLastRaceLogic);
customElements.define('horses-betting', WcHorsesBetting);
customElements.define('horses-future-races', WcHorsesFutureRaces);
customElements.define('horses-outcomes', WcHorsesOutcomes);
customElements.define('lotto-draws-offer', WcLottoDrawsOffer);
customElements.define('lotto-extended', WcLottoExtended);
customElements.define('lotto-games-menu', WcLottoGamesMenu);
customElements.define('lotto-header', WcLottoHeader);
customElements.define('lotto-numbers', WcLottoNumbers);
customElements.define('lotto-favourites', WcLottoFavorites);
customElements.define('lotto-tutorial', WcLottoTutorial);
customElements.define('offer-calendar', WcOfferCalendar);

Vue.config.productionTip = false;
Vue.use(PiniaVuePlugin);
Vue.use(Vuei18n);
const i18n = new Vuei18n(
    {
        silentTranslationWarn: true,
    },
);

Vue.filter('formatModifierName', (str, match, specifiers) => Common.formatModifierName(str, match, specifiers));
Vue.filter('offerlang', (str) => Common.offerlang(str));
Vue.filter('formatMatchDate', (str) => Common.formatMatchDate(str));
Vue.filter('formatLottoDrawDate', (str, returnObject) => Common.formatLottoDrawDate(str, returnObject));
Vue.filter('formatTicketMatchDate', (str) => Common.getLocalDate(str));
Vue.filter('formatSpecName', (str, match, specifiers) => Common.formatSpecName(str, match, specifiers));
Vue.filter('formatNum', (str, count, decimalSep, thousandSep) => Common.formatNum(str, count, decimalSep, thousandSep));
Vue.filter('formatOdd', (str) =>
{
    if (str === '-')
    {
        return i18n.t('NOODDSFORTHISMATCHATTHISMOMENT');
    }

    if (str === '--')
    {
        return i18n.t('NOODDSFORTHISBETGROUPOPENMATCHDETAILS');
    }

    return Common.formatOdd(str);
});

Vue.filter('parseTicketError', (data) =>
{
    let str = '';

    if (data.text !== undefined)
    {
        str = data.text;
    }
    else if (data.notice !== undefined)
    {
        str = data.notice;
    }
    else
    {
        str = data;
    }

    if (data.specifiers === undefined)
    {
        const found = str.match(/{#(.*?)}/g);
        if (found)
        {
            for (const item of found)
            {
                str = str.replace(item, item.replace('{#', '').replace('}', ''));
            }
        }

        // return i18n.t(str);
    }

    let strOut = '';

    if (data.eventId !== undefined)
    {
        strOut = `(${data.eventId}) `;
    }

    if (data.params !== undefined)
    {
        if (data.params.field !== undefined)
        {
            strOut += i18n.t(str, data.params.field);
            strOut += i18n.t(`_${data.params.field.toUpperCase()}`);
        }
        else
        {
            strOut += i18n.t(str, data.params);
        }
    }
    else if (data.specifiers !== undefined)
    {
        strOut += i18n.t(str, data.specifiers);
    }
    else
    {
        strOut += i18n.t(str);
    }

    return strOut;
});

Vue.filter('parseError', (data) =>
{
    let notice = '';

    if (data.errors !== undefined && data.code === 'field_errors')
    {
        for (const error of data.errors)
        {
            notice += `${i18n.t(`${error.notice}_${error.params.field.toUpperCase()}`)}`;
        }
    }
    else if (data.errors !== undefined && data.code === undefined)
    {
        for (const error of data.errors)
        {
            notice += `${i18n.t(`${error.notice.toUpperCase()}`)}`;
        }
    }
    else if (data.code === 'sql_value_used_in')
    {
        notice = `${i18n.t(`${data.notice}_${data.params.table.toUpperCase()}`)}<br>`;
    }
    else if (data.notice !== undefined)
    {
        notice = i18n.t(data.notice.toUpperCase(), data.params);
    }

    return notice;
});

Vue.filter('parseStringToTranslatable', (str) =>
{
    let strOut = '';

    const found = str.match(/{#(.*?)}/g);
    if (found)
    {
        for (const item of found)
        {
            strOut = str.replace(item, i18n.t(item.replace('{#', '').replace('}', '')));
        }
    }
    else
    {
        strOut = str;
    }

    return strOut;
});

Vue.filter('getLocalDateFromNanoTimestamp', (str) => Common.getLocalDateFromNanoTimestamp(str));
Vue.filter('getLocalDate', (str, format) =>
{
    if (typeof str === 'string')
    {
        if (str.includes('-'))
        {
            return Common.getLocalDate(str, format);
        }
        return Common.getLocalDateFromNanoTimestamp(Number(str));
    }
    return Common.getLocalDateFromNanoTimestamp(str);
});
Vue.filter('getLocalDateMonthYear', (str) => Common.getLocalDate(str, Common.localeSetup.dateFormat));
Vue.filter('getLocalTimeFormatted', (str) => Common.getLocalDate(str, 'HH:mm'));
Vue.filter('formatOutrightsTicketMatchDate', (str) =>
{
    const formatedDate = Common.getLocalDate(str);

    return formatedDate.replace('00:00', '');
});
Vue.prototype.$formatToLocalDate = (str) => Common.formatToLocalDate(str);
Vue.prototype.$predefinedLocalDateFormat = (str) => Common.predefinedLocalDateFormat(str);
Vue.prototype.$formatTicketMatchDate = (str, format) =>
{
    if (str.meta
    && str.meta.live)
    {
        return i18n.t('LIVEEVENT');
    }

    return Common.getLocalDate(str.eventDate, format);
};

Vue.prototype.$setCommonLangCode = (langCode) =>
{
    Common.setLangCode(langCode);
};

Vue.prototype.$getCurrencyAbbrv = (currency) =>
{
    const text = `${currency}_CURRENCYABBRV`;
    const translated = i18n.t(text);

    if (text === translated)
    {
        return currency;
    }

    return translated;
};

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'stableSort',
    {
        configurable: true,
        writable: true,
        value: function stableSort(compareFunction)
        {
            const len = this.length;

            if (len < 2)
            {
                return this;
            }

            const entries = Array(len);
            let index;

            // wrap values with initial indices
            for (index = 0; index < len; index += 1)
            {
                entries[index] = [index, this[index]];
            }

            // sort with fallback based on initial indices
            entries.sort(function sort(a, b)
            {
                const comparison = Number(this(a[1], b[1]));
                return comparison || a[0] - b[0];
            }.bind(compareFunction));

            // re-map original array to stable sorted values
            for (index = 0; index < len; index += 1)
            {
                [, this[index]] = entries[index];
            }

            return this;
        },
    });

// TODO see if this is used anymore
// eslint-disable-next-line no-extend-native
Date.prototype.getUTC = function getUTC()
{
    return new Date(this.getTime() + this.getTimezoneOffset() * 60 * 1000);
};

Vue.directive('click-outside',
    {
        bind(el, binding, vNode)
        {
            // Provided expression must evaluate to a function.
            if (typeof binding.value !== 'function')
            {
                const compName = vNode.context.name;
                let warn = `[Vue-click-outside:] provided expression ${binding.expression}`
                    + 'is not a function, but has to be';
                if (compName)
                {
                    warn += `Found in component ${compName}`;
                }

                console.warn(warn);
            }
            // Define Handler and cache it on the element
            const { bubble } = binding.modifiers;
            const handler = function handler(e)
            {
                if (bubble || (!el.contains(e.target) && el !== e.target))
                {
                    binding.value(e);
                }
            };
            el.__vueClickOutside__ = handler;

            // add Event Listeners
            document.addEventListener('click', handler);
        },
        unbind(el)
        {
            // Remove Event Listeners
            document.removeEventListener('click', el.__vueClickOutside__);
            el.__vueClickOutside__ = null;
        },
    });

router.beforeEach((to, from, next) =>
{
    document.title = (to.meta !== undefined && to.meta.title !== undefined) ? i18n.t(`PAGETITLE_${to.meta.title}`) : 'Demobet';

    // if(to.params.lang == undefined) to.params.lang = (store.state.globals.globals.langCode == 'en-GB') ? 'hr-HR' : 'en-GB';
    next();
});

Common.setTranslationCallback({
    callback(str = '', param = {})
    {
        return i18n.t(str, param);
    },
});

mainController.init();

const pinia = createPinia();

new Vue(
    {
        router,
        store,
        i18n,
        pinia,
        render: (h) => h(App),
    },
).$mount('#app');
